import React from "react";

import { Paragraph } from "@tvg/design-system";
import { NoUpcomingRacesWrapper } from "./styled-components";

import { NoUpcomingRacesProps } from "./types";

const NoUpcomingRaces = ({ title, hint }: NoUpcomingRacesProps) => (
  <NoUpcomingRacesWrapper>
    <Paragraph qaLabel="no-upcomingRaces-title" fontFamily="bold">
      {title}
    </Paragraph>
    <Paragraph qaLabel="no-upcomingRaces-hint">{hint}</Paragraph>
  </NoUpcomingRacesWrapper>
);

export default NoUpcomingRaces;
